import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./BasicReports.scss";
import Scorecard from "./Scorecard/Scorecard";
import SubjectWise from "./SubjectWise/SubjectWise";
import GoToAdvAnalytics from "./GoToAdvAnalytics/GoToAdvAnalytics";
import GoToAdvAnalytics1 from "./GoToAdvAnalytics1/GoToAdvAnalytics1";
import Buttons from "./Buttons/Buttons";
import PerformanceInsights from "../sharedAnalytics/performanceInsights";
import { MISTAKE_BOOK_PRACTICE_SETS_ANALYTICS_PATH } from "../../../MistakeBook/mistakeBookRoutes";
import isGetAnalyticsReportAitsStyle from "../../utils/isGetAnalyticsReportAitsStyle";

const AITS_YEARWISE_SOURCES = new Set(["paperlisting", "yearwise"]);

const BasicReports = ({ basicAnalytics }) => {
  const location = useLocation();
  const testDetails = useSelector((state) => state.examSlice.testDetails);
  const testType = useSelector((state) => state.examSlice.testType);
  const isMistakeBookPracticeSet =
    testDetails?.source === "mistake_book_practice_set" ||
    location.state?.fromMistakeBookPracticeSet === true ||
    location.pathname === MISTAKE_BOOK_PRACTICE_SETS_ANALYTICS_PATH;
  const showPerformanceInsights =
    testDetails?.practiceMode !== "practice" &&
    AITS_YEARWISE_SOURCES.has(String(testDetails?.source || ""));
  const hideReattempt = isGetAnalyticsReportAitsStyle({
    testDetails,
    testType,
    routeState: location.state,
  });

  return (
    <div className="basic-reports">
      <Scorecard basicAnalytics={basicAnalytics} />
      {!isMistakeBookPracticeSet ? <GoToAdvAnalytics /> : null}

      <SubjectWise subjectWiseAnalysis={basicAnalytics?.subject_wise_analysis} />

      {showPerformanceInsights ? (
        <PerformanceInsights analytics={basicAnalytics} />
      ) : null}

      {!isMistakeBookPracticeSet && hideReattempt ? (
        <div className="basic-reports__action-row">
          <GoToAdvAnalytics1 inline />
          <Buttons hideReattempt />
        </div>
      ) : (
        <>
          {!isMistakeBookPracticeSet ? <GoToAdvAnalytics1 /> : null}
          <Buttons hideReattempt={hideReattempt} />
        </>
      )}
    </div>
  );
};

export default BasicReports;
